import { Linkedin, Instagram, Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#1F2043] text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="inline-flex items-center gap-3 bg-white rounded-full pl-2 pr-5 py-2">
            <img
              src="/assets/sachet-logo.webp"
              alt="Sachet Foundation logo"
              className="h-9 w-auto"
            />
            <span className="font-heading font-semibold text-[#1F2043] text-sm tracking-tight">
              Sachet Foundation
            </span>
          </div>
          <p className="font-body mt-6 text-sm font-light text-white/60" data-testid="footer-coming-soon">
            Full website coming soon.
          </p>
          <div className="mt-7 flex items-center gap-3">
            <a
              href="#"
              aria-label="LinkedIn"
              data-testid="footer-linkedin-link"
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:bg-white/10 hover:text-white transition-colors duration-300"
            >
              <Linkedin className="w-4 h-4" />
            </a>
            <a
              href="#"
              aria-label="Instagram"
              data-testid="footer-instagram-link"
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:bg-white/10 hover:text-white transition-colors duration-300"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>
        <div className="md:col-span-4">
          <h3 className="font-heading text-xs font-semibold tracking-[0.24em] uppercase text-white/50">
            Reach us
          </h3>
          <div className="mt-5 flex flex-col gap-4">
            <a
              href="mailto:mayur.shelar@sachet.org.in"
              data-testid="footer-email-link"
              className="flex items-center gap-3 font-body text-sm font-light text-white/80 hover:text-white transition-colors duration-300"
            >
              <Mail className="w-4 h-4 text-[#BCCF00] shrink-0" />
              mayur.shelar@sachet.org.in
            </a>
            <a
              href="tel:+919309406707"
              data-testid="footer-phone-link"
              className="flex items-center gap-3 font-body text-sm font-light text-white/80 hover:text-white transition-colors duration-300"
            >
              <Phone className="w-4 h-4 text-[#BCCF00] shrink-0" />
              +91 93094 06707
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <h3 className="font-heading text-xs font-semibold tracking-[0.24em] uppercase text-white/50">
            Address
          </h3>
          <p className="mt-5 flex items-start gap-3 font-body text-sm font-light leading-relaxed text-white/80" data-testid="footer-address">
            <MapPin className="w-4 h-4 text-[#BCCF00] shrink-0 mt-0.5" />
            3rd Floor, Ashirwad Heights, Gangapur Road, Nashik &ndash; 13
          </p>
        </div>
      </div>
      <div className="mt-14 pt-7 border-t border-white/10">
        <p className="font-body text-xs font-light text-white/45" data-testid="footer-copyright">
          &copy; 2026 Sachet Foundation
        </p>
      </div>
    </div>
  </footer>
);
